/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import moment from 'moment';
import * as actionType from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const selectionList = (data) => {
  return {
    type: actionType.SELECTION_TYPE_OPTIONS,
    payload: data,
  };
};

export const dropdownUpdatedList = (data) => {
  return {
    type: actionType.DROPDOWN_UPDATED_LIST,
    payload: data,
  };
};

export const statusType = (val) => {
  return {
    type: actionType.STATUS_SELECTED_TYPE,
    payload: val,
  };
};

export const resetStoreDisputes = () => {
  return {
    type: actionType.RESET_DISPUTES_DATA,
  };
};

export const handleErrorMessages = (data) => ({
  type: actionType.HANDLE_ERROR_MESSAGE,
  errorMessagesInRedux: data,
});

export const handleErrorDetail = (data) => ({
  type: actionType.DETAIL_ERROR_MESSAGE,
  payload: data,
});

export const handleNDCErrorDetail = (data) => ({
  type: actionType.NDC_DETAIL_ERROR_MESSAGE,
  payload: data,
});

export const dispatchCommonDropdownData = (data) => ({
  type: actionType.GET_COMMON_DROPDOWN_DATA_CI,
  dropdown: data,
});

export const getCommonDropdownList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchManufacturerData = (data) => ({
  type: actionType.GET_MANUFACTURER_GRID_LIST,
  manufacturerList: data,
});

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.MANUFACTURER_DETAILS_REQUEST_MAILING, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(
          response && response.data && response.data.manufacturers
        )
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};

export const dispatchAssignedUsersData = (data) => ({
  type: actionType.ASSIGNED_USERS_LIST,
  payload: data,
});

export const getAssignedUsersList = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.ASSIGNED_TO_USERS_DISPUTE, {})
    .then((response) => {
      let finalResponse = [];
      if (
        response?.data?.message === 'Success' &&
        response?.data?.status === '001'
      ) {
        finalResponse = response.data.secUsers;
      }
      return finalResponse;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchSingleHeaderDetails = (data) => ({
  type: actionType.SINGLE_HEADER_DETAILS,
  payload: data,
});

export const dispatchDisputeHeaderDetails = (data) => ({
  type: actionType.DISPUTE_HEADER_DETAILS,
  payload: data,
});

export const getHeaderDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_DETAILS_HEADER, value)
    .then((response) => {
      return dispatch(dispatchDisputeHeaderDetails(response && response.data));
    })
    .catch((err) => {
      return null;
    });
};

export const dispatchDisputeBodyDetails = (data) => ({
  type: actionType.DISPUTE_BODY_DETAILS,
  payload: data,
});

export const getMainGridDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_DETAILS_MAIN_GRID, value)
    .then((response) => {
      let newObj =
        response?.data &&
        response?.data?.disputeDetails &&
        response?.data?.disputeDetails.map((element) => {
          if (element.ccOrigAmt) {
            const temp =
              element.ccOrigAmt % 1 !== 0
                ? element.ccOrigAmt.toFixed(2)
                : element.ccOrigAmt.toFixed(1);
            element.ccOrigAmt = `$ ${parseFloat(temp).toFixed(2)}`;
          } else {
            element.ccOrigAmt = `$ ${parseFloat(0).toFixed(2)}`;
          }

          if (element.ccOpenAmt) {
            const temp =
              element.ccOpenAmt % 1 !== 0
                ? element.ccOpenAmt.toFixed(2)
                : element.ccOpenAmt.toFixed(1);
            element.ccOpenAmt = `$ ${parseFloat(temp).toFixed(2)}`;
          } else {
            element.ccOpenAmt = `$ ${parseFloat(0).toFixed(2)}`;
          }
          return element;
        });
      return dispatch(dispatchDisputeBodyDetails(newObj || []));
    })
    .catch((err) => {
      dispatch(dispatchDisputeBodyDetails([]));
      return null;
    });
};

export const dispatchDisputeCorrespondenceTable = (data) => ({
  type: actionType.DISPUTE_DETAILS_CORRESPONDENCE,
  payload: data,
});

export const getAllCorrespondenceDetails = (value, flag) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_DETAILS_ALL_CORRESPONDENCE, value)
    .then((response) => {
      const newArr =
        response?.data &&
        response?.data?.disputeShowAllCorrespondence &&
        response?.data?.disputeShowAllCorrespondence.filter((item) => {
          if (item.createDt) {
            item.createDt = moment(item.createDt).format('MM/DD/YYYY');
          }
          if (item.responseDueDt) {
            item.responseDueDt = moment(item.responseDueDt).format(
              'MM/DD/YYYY'
            );
          }
          if (flag === true) {
            return item.lvl === 'MFG' || item.qtr === 'QTR';
          }
          return item.lvl === 'MFG';
        });
      return dispatch(dispatchDisputeCorrespondenceTable(newArr));
    })
    .catch((err) => {
      dispatch(dispatchDisputeCorrespondenceTable(err?.response?.data));
    });
};

export const dispatchDisputeNDCDetails = (data) => ({
  type: actionType.DISPUTE_NDC_DETAILS,
  payload: data,
});

export const singleDisputeNDCDetails = (data) => ({
  type: actionType.SINGLE_DISPUTE_NDC_DETAILS,
  payload: data,
});

export const getDisputeNdcDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NDC_DISPUTE_DETAILS, value)
    .then((response) => {
      let newObj =
        response?.data &&
        response?.data?.disputeNDCDetails &&
        response?.data?.disputeNDCDetails.map((element) => {
          if (element.disputedUnits !== undefined && element.disputedUnits !== null && 
            element.unitRebateAmt !== undefined && element.unitRebateAmt !== null) {
            element.origUra = element.disputedUnits * element.unitRebateAmt;
          }
          if (element.origUra) {
            const temp =
              element.origUra % 1 !== 0
                ? element.origUra.toFixed(2)
                : element.origUra.toFixed(1);
            element.origUra = `$ ${parseFloat(temp).toFixed(2)}`;
          } else {
            element.origUra = `$ ${parseFloat(0).toFixed(2)}`;
          }
          if (element.assignedDT) {
            element.assignedDT = moment(element.assignedDT).format(
              'MM/DD/YYYY'
            );
          }
          if (element.resolvedDT) {
            element.resolvedDT = moment(element.resolvedDT).format(
              'MM/DD/YYYY'
            );
          }
          return element;
        });
      return dispatch(dispatchDisputeNDCDetails(newObj));
    })
    .catch((err) => {
      return null;
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const getUnitConversionDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UNIT_CONVERSION_DETAIL, values)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return null;
    });
};
export const clearReduxForDisputeSerachScreen = () => (dispatch) => {
  dispatch(dispatchCommonDropdownData([]));
  dispatch(dispatchManufacturerData([]));
  dispatch(dispatchAssignedUsersData([]));
  dispatch(selectionList(''));
  dispatch(handleErrorMessages([]));
};
export const clearReduxForDisputeDetailScreen = () => (dispatch) => {
  dispatch(dropdownUpdatedList([]));
  dispatch(dispatchDisputeHeaderDetails([]));
  dispatch(dispatchSingleHeaderDetails([]));
  dispatch(dispatchDisputeBodyDetails(''));
  dispatch(dispatchDisputeCorrespondenceTable([]));
  dispatch(handleErrorDetail([]));
};
export const clearReduxForNdcDisputeDetailScreen = () => (dispatch) => {
  //dispatch(dispatchSingleHeaderDetails([]));
  dispatch(dispatchDisputeNDCDetails([]));
  dispatch(singleDisputeNDCDetails([]));
  dispatch(handleNDCErrorDetail(''));
  dispatch(statusType(''));
};

export const dispatchRecapGrid = (data) => ({
  type: actionType.GET_DISPLAY_RECAP_GRID,
  payload: data,
});

export const getDisplayRecapGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DISPUTE_CODE_RECAP, value)
    .then((response) => {
      dispatch(dispatchRecapGrid(response.data));
      dispatch({
        type: actionType.GET_DISPUTE_CODES,
        payload: response.data,
      });
      return response.data;
    })
    .catch((error) => {
      dispatch(dispatchRecapGrid(null));
      dispatch({
        type: actionType.GET_DISPUTE_CODES,
        payload: null,
      });
      return null;
    });
};
